export default __webpack_public_path__ + "static/media/comunicaciones.50676b7f.pdf";